import React, { Component } from 'react';
import CustomTab from 'containers/Tab';
import { TabData } from 'constants/tab';
import { TabPanel } from 'react-tabs';
import Promotional from './PromotionalSetting';
import Show from './ShowSettings';

class PromotionalSettings extends Component {
  state = {
    tabIndex: 0,
    subTabIndex: 0,
  };

  render() {
    return (
      <CustomTab
        selectedIndex={this.state.tabIndex}
        onGetIndex={(ind) => {
          this.setState({ tabIndex: ind }, () => {});
        }}
        wantIndex
        data={TabData.promotionalSetting.filter((d) => !d.hideTab)}
        tabHeaderClass="customerMaintab"
        className="moreTabScroll"
      >
        <div className="configurationWrapper pt-0">
          <TabPanel>
            <Promotional />
          </TabPanel>
          <TabPanel>
            <Show />
          </TabPanel>
        </div>
      </CustomTab>
    );
  }
}

export default PromotionalSettings;
